import { Component, HostBinding, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { TranslateService } from '@mono-repo/util';

@Component({
  selector: 'app-logout',
  templateUrl: './logout.component.html',
})
export class LogoutComponent implements OnInit {
  @HostBinding('class') class = 'dt-login dt-c-interactive-dialog';
  public heading: string;
  public message: string;
  /****************************************************************
   * constructor and initialization
   ***************************************************************/
  constructor(
    private route: ActivatedRoute,
    private translateService: TranslateService,
  ) {
    this.translateService.setCurrentModuleTranslation('logout');
  }

  ngOnInit(): void {
    this.route.queryParams.subscribe({
      next: (params) => {
        this.heading = params['heading'];
        this.message = params['message'];
      },
    });
  }
}
